import { useState } from 'react'
import {FetchEventSource} from "../api/FetchEventSource";
import {GenerativeAIContent, GenerativeAIPart} from "shared";

interface EventSourceConfig {
  url: string
  onMessage?: (data: string) => void
  onError?: (error: any) => void
  onClose?: (originalPayload: EventSourcePayload) => void
}

interface EventSourcePayload {
  parts: GenerativeAIPart[];
  history: GenerativeAIContent[];
  projectId: string;
  fieldHint: string;
}


export const useEventSource = (config: EventSourceConfig) => {
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  let messageChunks = ''

  const connect = async (payload: EventSourcePayload) => {
    setIsLoading(true)
    const eventSource = new FetchEventSource(config.url)

    eventSource.addEventListener('message', (event) => {
      setMessage((prev) => prev + event.data)
      messageChunks += event.data
      config.onMessage?.(event.data)
    })

    eventSource.addEventListener('error', (error) => {
      setIsLoading(false)
      setMessage('')
      config.onError?.(error)
    })

    eventSource.addEventListener('close', () => {
      setIsLoading(false)
      setMessage('')
      eventSource.close()
      config.onClose?.(payload)
    })

    await eventSource.connect(payload)
  }

  return {
    isLoading,
    message,
    connect,
    getMessageChunks: () => messageChunks,
  }
}
